import React, { useState } from 'react';

import { Button } from 'components/ui/button';
import Tooltip from 'components/tooltip';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import SendRepEmailModal from './send_rep_email_modal';

interface CompanyUser {
  value: number;
  label: string;
  primaryBroker: boolean;
}

interface Props {
  companyUsers: CompanyUser[];
  hasPendingChanges: boolean;
  icon?: IconDefinition | null;
  partnerNames: string[];
  previouslySent: boolean;
  sendEmailSyndicationPath: string;
}

export default function SendRepEmailButton({
  companyUsers,
  hasPendingChanges,
  icon = null,
  partnerNames,
  previouslySent,
  sendEmailSyndicationPath
}: Props) {
  const buttonText = 'Send Rep Email';
  const [showModal, setShowModal] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const activeButton = () => (
    <Button icon={icon} onClick={() => setShowModal(true)}>
      {buttonText}
    </Button>
  );

  const inactiveButton = () => (
    <Tooltip content="No pending changes to send" dark={true} placement="bottom">
      <Button disabled icon={icon}>
        {buttonText}
      </Button>
    </Tooltip>
  );

  return (
    <React.Fragment>
      {(hasPendingChanges && !buttonDisabled) ? activeButton() : inactiveButton()}

      <SendRepEmailModal
        afterSend={() => setButtonDisabled(true)}
        companyUsers={companyUsers}
        partnerNames={partnerNames}
        previouslySent={previouslySent}
        sendEmailSyndicationPath={sendEmailSyndicationPath}
        show={showModal}
        onHide={() => setShowModal(false)}
      />
    </React.Fragment>
  );
}
